import React, { useEffect } from 'react';
import { MobileContainer } from '@components/organism/MobileContainer';
import { EditPersonalData } from '@components/molecules/EditPersonalData';
import { useGetUser } from '@services/useGetUser';
import { useData } from '@hooks/useData';

export function EditMyProfile() {
    const { user } = useData();
    const { request: requestUser, loading } = useGetUser();

    useEffect(() => {
        requestUser();
    }, []);

    return <MobileContainer>{loading || !user?.data ? <></> : <EditPersonalData userData={user.data} />}</MobileContainer>;
}
